<app-main-nav-bar></app-main-nav-bar>
<!--1-->
<div class="page-wrapper bg-red p-t-180 p-b-100">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-body">
        <div class="new-person elem" style="display: block;">
          <div class="row">
            <div class="col col-12">
              <div class="head">
                <h2>افزودن بیمه گذار جدید</h2>
                <p>لطفا اطلاعات پایه و اولیه بیمه گذار را وارد کنید</p>
              </div>
            </div>
          </div>
          <form [formGroup]="subRequestForm" (ngSubmit)="addNewSubRequest()">
            <div class="row">
              <div class="col col-12">
                <app-date-picker-field [fieldName]="'birthday'" [fieldLabel]="'تاریخ تولد'" [Group]="subRequestForm">
                </app-date-picker-field>
                <app-select-field [Group]="subRequestForm" [fieldLabel]="'بیمه پایه'" [options]="basicInsuranceList"
                                  [fieldName]="'insurance'" [Icon]="true"></app-select-field>
                <app-select-field [Group]="subRequestForm" [fieldName]="'gender'" [options]="genderList"
                                  [fieldLabel]="'جنسیت'" [Icon]="true">
                </app-select-field>
                <app-select-field [Group]="subRequestForm" [fieldName]="'relation'" [options]="relationList"
                                  [fieldLabel]="'رابطه'" [Icon]="true">
                </app-select-field>
                <app-input-field [Group]="subRequestForm" [fieldLabel]="'قد'" [fieldName]="'height'"
                                 [dataType]="['number']" [Icon]="true" (OnChange)="calculateBMI()">
                </app-input-field>
                <app-input-field [Group]="subRequestForm" [fieldName]="'weight'" [dataType]="['number']"
                                 [fieldLabel]="'وزن'" [Icon]="true" (OnChange)="calculateBMI()">
                </app-input-field>
                <app-input-field [Group]="subRequestForm" [fieldLabel]="'BMI'" [fieldName]="'BMI'" [disabled]="true" [dataType]="['number']">
                </app-input-field>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col col-12">
                <app-custom-button
                  [BackButton]="true"
                  [Show]="true"
                  [LabelText]="'افزودن بیمه گدار جدید'"
                  (OnClick)="addNewSubRequest()"
                  [backUrl]="'health/family/new-request'"
                ></app-custom-button>
              </div>
            </div>
            <!--            <div class="row">-->
            <!--              <div class="col col-6">-->
            <!--                <button type="submit" class="btn1">-->
            <!--                  <span>افزودن بیمه گذار</span>-->
            <!--                </button>-->
            <!--              </div>-->
            <!--            </div>-->
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
